<template lang="pug">
div
  .radio.mb-4(
    v-for="(point, key) in answer_values"
    :key="key"
  )
    v-checkbox(
      hide-details
      :value="point.value"
      @change="onChangeCheckbox(point.value)"
    )
      template(v-slot:label)
        span(v-text="point.label")
        v-tooltip(
          v-if="point.info"
          max-width="300"
          bottom
        )
          template(v-slot:activator="{ on }")
            v-icon.ml-2(v-on="on") mdi-information-outline
          span(v-text="point.info")
</template>
<script>
export default {
  name: 'Radio',
  props: ['answer_values', 'value'],
  computed: {
    input: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    onChangeCheckbox(value) {
      let values = this.splitAnswers(this.value)
      if (values.length > 0 ) {
        if (
          values
          && values.filter(v => v === value).length > 0
        ) {
          this.$emit('input', values
            .filter(v => v != value)
            .join(',,'))
        } else {
          values.push(value)
          this.$emit('input', values.join(',,'))
        }
      } else {
        this.$emit('input', value)
      }
    },
    splitAnswers(val) {
      if(val === '' || val === null) return []
      return val.split(',,')
    }

  }
}
</script>